import { useMixpanel } from '@/context/mixpanel'
import { useTheme } from '@/context/theme'
import { Theme } from '@/theme'
import { cn } from '@/utils/cn'
import { RadioGroup, RadioTile } from '../common/radio'
import { ComputerIcon } from '../icons/computer'
import { MoonIcon } from '../icons/moon'
import { SunIcon } from '../icons/sun'

const themeOptions = ['system', Theme.LIGHT, Theme.DARK] as const

interface Props {
  className?: string
}

export const AppearanceSettings = ({ className }: Props) => {
  const { trackEvent } = useMixpanel()
  const [theme, setTheme, { definedBy }] = useTheme()

  const handleThemeChange = (value: string) => {
    value === 'system' ? setTheme(null) : setTheme(value as Theme)
    trackEvent('App theme change', { Theme: value })
  }

  return (
    <div className={cn('hocus-within:text-accent text-sm transition-color', className)}>
      <span>Theme</span>
      <RadioGroup
        className="mt-1 grid grid-cols-3"
        value={definedBy === 'SYSTEM' ? 'system' : theme ? theme.toString() : 'system'}
        onValueChange={handleThemeChange}
      >
        {themeOptions.map((option) => (
          <RadioTile id={option} value={option} key={option} title={option === 'system' ? 'Auto' : option}>
            <p className="inline-flex items-center gap-2">{getThemeOption(option)}</p>
          </RadioTile>
        ))}
      </RadioGroup>
    </div>
  )
}

function getThemeOption(theme: (typeof themeOptions)[number]) {
  switch (theme) {
    case 'system':
      return (
        <>
          <ComputerIcon size={20} />
          Auto
        </>
      )
    case Theme.LIGHT:
      return (
        <>
          <SunIcon size={20} /> Light
        </>
      )
    case Theme.DARK:
      return (
        <>
          <MoonIcon size={20} />
          Dark
        </>
      )
  }
}
